import { api } from '../api';

const menusPath = `/menus`;

export const getMenus = () => api.get(`${menusPath}`);

export const getMenusByUser = userId => api.get(`${menusPath}/user/${userId}`);
